import { useCallback, useEffect, useState } from "react";
import { Button, Container } from "react-bootstrap";
import PageTitle from "../../components/PageTitle";

import { Headers, TableActions } from "../../assets/interfaces/commom_interfaces";
import { RangeSelection, SearchParams } from "../../assets/interfaces/FX_POS_Interfaces";
import FXTable from "../../components/Common/FalchionTable/FXTable";
import { GetInfoCommonAPI, PostCommonAPI } from "../../POS/APIServices/POS_API_Services";
import HelperService from "../../Services/HelperService";
import CommonModalGroupMembers from "./CreateGroup";
import CommonMembersList from "./MembersList";
import { FEATURE_CODES } from "../../FeaturePermissions/featureCodes.constants";
import { UseScreenFeatures } from "../../FeaturePermissions/UseScreenFeatures.ts";

const GroupList = () => {
    const SCREEN_CODE = 'CRM_CUSTOMER_SEGMENTS_PROFILES';
    const C = FEATURE_CODES;
    const access = UseScreenFeatures(SCREEN_CODE);
    const canManageGroups = access.canShow(C.MANAGE_GROUPS);
    const headers: Headers[] = [
        {
            label: "Created Date",
            key: "created_at",
            headerType: "DATE",
            sortingKey: "created_at",
            isSorting: true,
            isDefaultSorting: false,
        },
        {
            label: "Group Name",
            key: "title",
            headerType: "STRING",
            sortingKey: "title",
            isSorting: true,
            isDefaultSorting: false,
        },
        {
            label: "Description",
            key: "description",
            headerType: "STRING",
            sortingKey: "description",
            isSorting: true,
            isDefaultSorting: false,
        },
        {
            label: "Members",
            key: "members",
            headerType: "STRING",
            onColumnClick: canManageGroups ? (row: any) => {
                getDetails(row.id, 'MEMBERS');
            } : undefined,
            sortingKey: "members",
            isSorting: true,
            isDefaultSorting: false,
        }
    ];
    const actions: TableActions[] = canManageGroups ? [
        {
            type: "VIEW/EDIT",
            onClick: (row: any) => {
                getDetails(row.id, 'EDIT');
            },
            variant: "success",
            label: "View",
        },
        {
            type: "DELETE",
            variant: "danger",
            delete_api: 'groups/',
            label: "View",
        }
    ] : []

    const [list, setList] = useState([]);
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [selectedRange, setSelectedRange] = useState<RangeSelection>({ startDate: new Date(new Date().setDate(new Date().getDate() - 30)), endDate: new Date() });
    const [searchParam, setSetSearchParam] = useState<SearchParams>({
        page: 1, limit: 10, sortBy: "created_at", orderBy: "DESC", keyword: "", outletId: ""
    })
    const [showGroupModal, setShowGroupModal] = useState<boolean>(false);
    const [showMembersModal, setShowMembersModal] = useState<boolean>(false);
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [membersList, setMembersList] = useState<any[]>([]);
    const [selectedGroup, setSelectedGroup] = useState<any>(null);
    const [searchFilters, setFilters] = useState(
        headers.reduce((acc, header) => {
            acc[header.key] = '';
            return acc;
        }, {} as { [key: string]: string })
    );
    const getList = useCallback(() => {
        const fromDate = selectedRange.startDate ? (HelperService.getAPIFormatedDate(selectedRange.startDate) ?? '') : '';
        const toDate = selectedRange.endDate ? (HelperService.getAPIFormatedDate(selectedRange.endDate) ?? '') : '';
        searchFilters.from_date = fromDate;
        searchFilters.to_date = toDate;
        setCount(0);
        setLoading(true);
        PostCommonAPI(searchFilters, 'groups/list', '', true).then((res: any) => {
            setList(res.data || []);
            setLoading(false);
            setCount(res.total_count);
        });
    }, [selectedRange, searchFilters]);

    useEffect(() => {
        if (selectedRange.startDate && selectedRange.endDate) {
            getList();
        }
    }, [searchFilters, searchParam, selectedRange, getList]);

    const handleGroupMembersClose = () => {
        setShowGroupModal(false);
    };
    const handleMembersClose = () => {
        setMembersList([]);
        setShowMembersModal(false);
    };
    const handleGroupMembersSubmit = (data: any) => {
        setShowGroupModal(false);
        getList();
    };

    const getDetails = (id: any, type: string) => {
        GetInfoCommonAPI('groups/info/' + id).then((res: any) => {
            if (type === 'EDIT') {
                setIsEdit(true);
                setSelectedGroup(res);
                setShowGroupModal(true);
            } else {
                setMembersList(res.members);
                setShowMembersModal(true);
            }
        })
    }

    const handleCommonFilterChange = (params: any | null, type: string) => {
        if (type === 'OUTLET') {
            getList()
        } else if (type === 'RANGE') {
            setSelectedRange({
                ...params,
                startDate: params?.startDate || null,
                endDate: params?.endDate || null
            })
        }
    };
    return (
        <>
            <Container fluid className="page-container">
                <PageTitle title="Groups" backArrow={true} changeEvent={(type, value) => {
                    handleCommonFilterChange(value, type);
                }} />

                {canManageGroups && (
                    <div className="d-flex justify-content-end gap-3 mb-3">
                        <Button variant="primary" onClick={() => {
                            setShowGroupModal(true);
                            setIsEdit(false);
                            setSelectedGroup(null);
                        }}>Create Group</Button>
                    </div>
                )}
                <div className="table-card border-0 mb-4">
                    <FXTable headers={headers} data={list} actions={actions}
                        searchParam={searchParam}
                        setSearchParams={setSetSearchParam}
                        searchRequired={true}
                        filterRequired={true}
                        loader={loading}
                        paginationRequired={true}
                        listCall={() => {
                            getList()
                        }}
                        setSearchFilters={setFilters}
                        searchFilters={searchFilters}
                        exportOption={{
                            api: "groups/list",
                            fileName: "groups_",
                        }}
                        paginationProps={{
                            totalItems: count,
                            itemsCountPerPage: 10,
                        }} />
                </div>
            </Container>
            {showGroupModal &&
                <CommonModalGroupMembers isEdit={isEdit} editData={selectedGroup} show={showGroupModal} onClose={handleGroupMembersClose} onSubmit={handleGroupMembersSubmit} />
            }
            {showMembersModal && <CommonMembersList show={showMembersModal} data={membersList} onClose={handleMembersClose} />}
        </>
    );
}

export default GroupList;
